import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { VERSION } from '@ideapa/app-common';
import { LoginResponseDto } from '@ideapa/common-dto';
import { FormGroupState } from 'ngrx-forms';
import { AuthFacade } from '../../+state/auth.facade';
import { MAVerifyCodeFormValue } from '../../+state/auth.reducer';
import { AuthService } from '../../auth.service';

@Component({
  standalone: false,
  selector: 'ideapa-microsoft-authenticator-verify',
  templateUrl: './microsoft-authenticator-verify.container.html',
  styleUrls: ['./microsoft-authenticator-verify.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicrosoftAuthenticatorVerifyContainer implements OnInit {
  verifyMAForm$ = this.authFacade.selectVerifyMAForm$;
  loginResponse: LoginResponseDto | null = null;
  constructor(
    @Inject(VERSION) public version: string,
    private authFacade: AuthFacade,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loginResponse = this.authService.getLoginResponse();
  }

  async onSubmit(form: FormGroupState<MAVerifyCodeFormValue>) {
    if (form.isValid) {
      if (this.loginResponse) {
        this.authFacade.verifyMAOTP(
          form.controls.otpCode.value,
          this.loginResponse
        );
      } else {
        this.authFacade.missingLoginResponse();
      }
    }
  }
}
